import React from 'react';
import { hasTx, tx } from './i18n';
import { answerGroups, answerWithUnit } from './sampleAnswers';
import './sampleAnswersTable.css';

// A column's heading: its short name (ui.sample_answers.heading.<code>, "Tissue" for the form's
// "Tissue / Cell Type"), so each heading stays one line (2026-10-29: it wrapped to four);
// a column without one shows the form's own name.
const heading = (column) => {
  const key = `ui.sample_answers.heading.${column.code}`;
  return hasTx(key) ? tx(key) : column.label;
};

// A list of samples with what the customer wrote of each, in the groups of sampleAnswers: a group's
// first column is its heading and its answer, the other columns' names and answers under them, so the
// whole form fits the page's width without scrolling sideways. `lead` are the columns before the
// answers (their name, our code, where it is), each { key, label, cell(sample, index) }. On a phone
// each row stacks, every cell under its heading.
export default function SampleAnswersTable({ columns, samples, lead = [], flat = false }) {
  const groups = answerGroups(columns, samples);
  return <div className={`xo-sat-wrap${flat ? ' is-flat' : ''}`}><table className="xo-sat">
    <thead><tr>
      {lead.map((entry) => <th key={entry.key} scope="col">{entry.label}</th>)}
      {groups.map((group) => <th key={group[0].code} scope="col">{heading(group[0])}
        {group.length > 1 && <small>{group.slice(1).map(heading).join(' · ')}</small>}</th>)}
    </tr></thead>
    <tbody>{samples.map((sample, index) => <tr key={sample.code ?? sample.sampleName ?? index}>
      {lead.map((entry) => <td key={entry.key} data-label={entry.label}>{entry.cell(sample, index)}</td>)}
      {groups.map((group) => {
        const [first, ...rest] = group.map((column) => answerWithUnit(columns, column, sample.answers));
        const more = rest.filter(Boolean);
        return <td key={group[0].code} data-label={heading(group[0])}>{first}{more.length > 0 && <small>{more.join(' · ')}</small>}</td>;
      })}
    </tr>)}</tbody>
  </table></div>;
}
